import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'pence' })
export class PencePipe implements PipeTransform {
    transform(value: number) {
        return `${parseFloat((value * 100).toFixed(2))}p`;
    }
}